export const AppleButton = null

export const appleAuth = {}
